import React, { useState } from "react";
import { DialogComponent } from "../common/DialogComponent";
import IDFTermsOfUse from "../Dialogs/IDFTermsOfUse";
import { domToReact } from "html-react-parser";
import { useForm } from "react-hook-form";
import { useSelector } from "react-redux";
import { ApplicationState } from "../../store";
import { STEP_TWO_FACTOR_AUTHENTICATION, STEP_PERSONAL_INFORMATION_ADDRESS_INFORMATION } from "./ReCompleteRegistrationUtil";
import RenderIcons from "../../Assets/css/_icons/partner_icon/RenderIcons";
import { useButtonText } from "../commonConstants";
interface IProps {
    reCompleteRegistrationState?: any;
    setReCompleteRegistrationState?: any;
}
interface IState {
    TermsData: any;
    isAgree: boolean;
}

const Terms = ({ reCompleteRegistrationState, setReCompleteRegistrationState }: IProps) => {
    const { handleSubmit } = useForm({
        mode: "onTouched",
        criteriaMode: "all",
    });

    const [Termsdialog, setTermsDialog] = useState(false);
    const [state, setState] = useState<IState>({ TermsData: {}, isAgree: reCompleteRegistrationState.isAgree ? reCompleteRegistrationState.isAgree : false });
    const hasSontiqBrand = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.hasSontiqBrand
            ? state.configurationState.configuration.partnerConfig.hasSontiqBrand === "true"
                ? true
                : false
            : false
    );
    const isEBPartner = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.partnerId
            ? state.configurationState.configuration.partnerConfig.partnerId === 542
                ? true
                : false
            : false
    );
    const isPreviousOrBack = useButtonText()[1];
    const handleCloseTermsDialog = (): any => {
        setTermsDialog(false);
    };

    const checked = () => {
        if (state.isAgree) {
            setState({ ...state, isAgree: false });
            return;
        }
        setState({ ...state, isAgree: true });
    };

    const onSubmit = (data: any) => {
        setReCompleteRegistrationState({
            ...reCompleteRegistrationState,
            step: STEP_TWO_FACTOR_AUTHENTICATION,
            isAgree: true,
        });
    };

    const options = {
        replace: ({ attribs, children }: any) => {
            if (!attribs) return;
            if (attribs.hasOwnProperty("href")) {
                if (attribs.href.indexOf("TermsAndConditions") !== -1) {
                    return hasSontiqBrand ? (
                        <a href="https://www.sontiq.com/terms-of-use/" target="_blank" rel="noreferrer">
                            {domToReact(children, options)}
                        </a>
                    ) : isEBPartner ? (
                        <a href="https://www.identityforce.com/terms-of-use" target="_blank" rel="noreferrer">
                            Terms of Use
                        </a>
                    ) : (
                        <a href="javascript:void(0)" onClick={() => setTermsDialog(true)}>
                            {domToReact(children, options)}
                        </a>
                    );
                }
            }
        },
    };

    const setPrevious = () => {
        setReCompleteRegistrationState({
            ...reCompleteRegistrationState,
            step: STEP_PERSONAL_INFORMATION_ADDRESS_INFORMATION,
        });
    };

    const isIDFUser = () => {
        return true;
    };

    return (
        <div className="row" id="content">
            <div className="col-xs">
                <div className="box box-has-shadow offset-padding">
                    <div className="box-header">
                        <div className="box-title-container">
                            <div className="box-title-icon" aria-hidden="true">
                                <RenderIcons iconName={"user"} />
                            </div>
                            <div className="box-title-text">
                                <h2 className="box-title">{hasSontiqBrand || isIDFUser() || isEBPartner ? "Terms of Use" : "Terms & Conditions"}</h2>
                            </div>
                        </div>
                    </div>
                    <div className="box-content">
                        <form id="form-terms" onSubmit={handleSubmit(onSubmit)}>
                            <div className="row between-sm">
                                <div className="col-xs-12 col-sm-7 col-no-gutter">
                                    <p>
                                        In order to complete your registration you must agree to the{" "}
                                        {hasSontiqBrand || isIDFUser() || isEBPartner ? "terms of use" : "terms and conditions"}.
                                    </p>
                                    <div className="margin-bottom-l"></div>
                                    <div className="form-input">
                                        <label className="form-checkbox-label" htmlFor="isAgree">
                                            <input type="checkbox" id="isAgree" name="isAgree" onChange={() => checked()} checked={state.isAgree} />
                                            <span className="form-checkbox-label-text">
                                                I agree to the{" "}
                                                <span className="default_link" onClick={() => setTermsDialog(true)}>
                                                    <a
                                                        href="#"
                                                        onClick={(e) => e.preventDefault()}
                                                        onContextMenu={(e) => {
                                                            e.preventDefault();
                                                        }}
                                                        className="default_link"
                                                    >
                                                        Terms of Use
                                                    </a>
                                                </span>
                                                .
                                            </span>
                                        </label>
                                    </div>
                                </div>
                            </div>
                            <div className="margin-vertical-l"></div>
                            <div className="row between-xs">
                                <div className="col-xs col-no-gutter flex-grow-null"></div>
                                <div className="col-xs col-no-gutter flex-grow-null">
                                    <ul className="list-inline list-reset">
                                        <li className="margin-left-s">
                                            <button
                                                type="button"
                                                className="btn-default
                                                    btn-default btn-min-width"
                                                onClick={() => setPrevious()}
                                            >
                                                <span className="btn-text">{isPreviousOrBack}</span>
                                            </button>
                                        </li>
                                        <li className="margin-left-s">
                                            <button
                                                type="submit"
                                                onClick={() => {
                                                    window.addToDataLayer({ event: "Agree and Continue Button Clicked" });
                                                }}
                                                disabled={!state.isAgree}
                                                className="btn-default btn-primary btn-min-width"
                                            >
                                                <span className="btn-text">Agree & Continue</span>
                                            </button>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>

            {Termsdialog && (
                <DialogComponent bodyClass="dialog-content width-lg" dialogId="termsDialog" title="Terms of Use" closeDialog={handleCloseTermsDialog}>
                    <IDFTermsOfUse dialogId="termsDialog" />
                </DialogComponent>
            )}
        </div>
    );
};

export default Terms;
